"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.rag.name': 'Knowledge Base',
    'tools.rag.description': 'Search and retrieve relevant information from knowledge base documents',
};
